import { HTMLAttributes } from 'react';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';

export enum MListTextPairVariant {
  BodyLeftRight = 'BodyLeftRight',
  BodyLeftLeft = 'BodyLeftLeft',
  SubheaderLeftRight = 'SubheaderLeftRight',
  SubheaderLeftLeft = 'SubheaderLeftLeft',
}

type BodyPairAllowedProps = HTMLAttributes<HTMLDivElement> & {
  variant: MListTextPairVariant.BodyLeftRight | MListTextPairVariant.BodyLeftLeft;
  aBodyLeft: ABodyProps;
  aBodyRight: ABodyProps;
};

type SubheaderPairAllowedProps = HTMLAttributes<HTMLDivElement> & {
  variant: MListTextPairVariant.SubheaderLeftRight | MListTextPairVariant.SubheaderLeftLeft;
  aSubheaderLeft: ASubheaderProps;
  aSubheaderRight: ASubheaderProps;
};

export type MListTextPairProps = BodyPairAllowedProps | SubheaderPairAllowedProps;
